import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const ClientRegistersModule = lazy(loadModule);

export default ClientRegistersModule;
